"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentIn = void 0;
class EnvironmentIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EnvironmentIn.attributeTypeMap;
    }
}
exports.EnvironmentIn = EnvironmentIn;
EnvironmentIn.discriminator = undefined;
EnvironmentIn.attributeTypeMap = [
    {
        "name": "createdAt",
        "baseName": "createdAt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "eventTypes",
        "baseName": "eventTypes",
        "type": "Array<EventTypeIn>",
        "format": ""
    },
    {
        "name": "settings",
        "baseName": "settings",
        "type": "SettingsIn",
        "format": ""
    },
    {
        "name": "version",
        "baseName": "version",
        "type": "number",
        "format": "int"
    }
];
//# sourceMappingURL=EnvironmentIn.js.map